export default "__VITE_ASSET__Dyr9Kd14__"